module.exports = __webpack_public_path__ + "static/media/about1.2a96fa46.jpg";